import { getShape1D } from 'ml-peak-shape-generator';
/**
 * Append 2 properties to the peaks, shape and fwhm
 */
export function setShape(peaks, options = {}) {
    let { shape = { kind: 'gaussian' } } = options;
    let shapeInstance = getShape1D(shape);
    return peaks.map((peak) => ({
        ...peak,
        shape: { fwhm: shapeInstance.widthToFWHM(peak.width), ...shape },
    }));
}
//# sourceMappingURL=setShape.js.map